/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ChallengeBucket,
  ChallengeBucket$inboundSchema,
} from "./challengebucket.js";

export type ListChallengeBucketsResult = {
  /**
   * The challenge buckets.
   */
  buckets: Array<ChallengeBucket>;
  /**
   * Total number of matching buckets for pagination.
   */
  total: number;
};

/** @internal */
export const ListChallengeBucketsResult$inboundSchema: z.ZodMiniType<
  ListChallengeBucketsResult,
  unknown
> = z.object({
  buckets: z.array(ChallengeBucket$inboundSchema),
  total: z.int(),
});

export function listChallengeBucketsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListChallengeBucketsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListChallengeBucketsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListChallengeBucketsResult' from JSON`,
  );
}
